<template>
    <div v-if="loaded">
        <div v-if="magazines.length > 0" class="flex flex-wrap flex-col mt-2">
            <label class="text-sm font-bold block p-1">Select Magazine</label>
            <div class="space-x-4 flex">
                <div
                    class="bg-gray-light border border-gray-dark flex rounded-md shadow-sm"
                >
                    <div class="flex items-center px-2">
                        <label for="operator" class="sr-only">Action</label>
                        <select
                            id="operator"
                            name="operator"
                            class="p-2 bg-transparent border-transparent h-full rounded-md sm:text-sm outline-none font-bold"
                            v-model="variables.id"
                        >
                            <option :value="null" disabled>
                                Select magazine
                            </option>
                            <option
                                v-for="(magazine, index) in magazines"
                                :key="index"
                                :value="magazine.id"
                            >
                                {{ magazine.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <p class="bg-primary-lighter p-2 rounded text-sm">
                There are no magazines in your account yet. Please
                <a
                    class="py-1 rounded text-primary font-bold underline"
                    href="/magazines"
                    target="_blank"
                    >create a magazine</a
                >
                first and come back to use it.
            </p>
        </div>
    </div>
    <div v-else>
        <loading />
    </div>
</template>

<script>
import Loading from "../utilities/Loading.vue";
export default {
    components: { Loading },
    props: {
        // If any current spell is passed?
        spell: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            loaded: false,
            magazines: [],
            variables: {
                id: this.spell ? this.spell.variables.id : "",
            },
        };
    },
    mounted() {
        this.getMagazines();
    },
    watch: {
        $data: {
            handler() {
                this.syncData();
            },
            deep: true,
        },
    },
    methods: {
        syncData() {
            this.$emit(
                "change",
                this.magazines.length > 0
                    ? { name: "magazine", variables: this.variables }
                    : null
            );
        },
        getMagazines() {
            axios
                .get(`/api/magazines`)
                .then((response) => {
                    this.loaded = true;
                    this.magazines = response.data.data;
                    this.variables.id =
                        this.spell && this.spell.variables.id
                            ? this.spell.variables.id
                            : this.magazines.length > 0
                            ? this.magazines[0].id
                            : null;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>

<style></style>
